export default Object.freeze({
    Filter: 'Filter',
    OpenFilterOptions: 'Open filter options',
    CloseFilterOptions: 'Close filter options',
    CloseRSVPForm: 'Close RSVP form',
    ApplyFilterOptions: 'Apply filter options',
    ClearFilterOptions: 'Clear filter options',
    CloseFilterOptions: 'Close filter options',
    SelectEventViewType: 'Select the event view type',
    ListView: 'List view',
    CalendarView: 'Calendar view',
    FilterEvents: 'Filter Events',
    Featured: 'Featured',
    FeaturedEvent: 'Featured Event',
    FeaturedEvents: 'Featured Events',
    AllEvents: 'All Events',
    Apply: 'Apply',
    Clear: 'Clear',
    Close: 'Close',
    Date: 'Date',
    Tags: 'Tags',
    Categories: 'Categories',
    ChooseADate: 'Choose a date',
    EventDate: 'Event Date',
    EventLocation: 'Event Location',
    EventOrganizer: 'Event Organizer',
    EventTickets: 'Event Tickets',
    EventType: 'Event Type',
    MCPrivacyStatement: 'We respect your privacy, see our <a href="https://support.moderncampus.com/product-privacy-policy.html" target="_blank">policy</a>.',
    GoogleRecaptchaStatement: 'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.',
    BuyTickets: 'Buy Tickets',
    OrganizedBy: 'Organized by',
    Postponed: 'Postponed',
    Cancelled: 'Cancelled',
    EventPostponedTitle: 'This event is postponed',
    EventCancelledTitle: 'This event is cancelled',
    EventPostponedColon: 'Event Postponed: ',
    EventCancelledColon: 'Event Cancelled: ',
    MonthView: 'Month view',
    WeekView: 'Week view',
    DayView: 'Day view',
    Search: 'Search',
    SearchForEvents: 'Search for events',
    SearchResultsFor: 'Search Results for {{query}}',
    SelectView: 'Select view',
    SpotsAvailable: '{{spots}} Spots Available',
    ThankYouForRegistering: 'Thank you for registering!',
    ToggleRSVPform: 'Toggle RSVP form',
    Register: 'Register',
    RegisterNow: 'Register now',
    RSVP: 'RSVP',
    RSVPFormInstructions: 'Please enter your details below',
    Name: 'Name',
    EmailAddress: 'Email address',
    RegisterToAttend: 'Register to Attend',
    CancelAttendance: 'Cancel Attendance',
    Submit: 'Submit',
    ViewEventSeries: 'View Event Series...',
    EmailOrganizer: 'Email organizer',
    RSVPInvalidName: 'name is required.',
    RSVPInvalidEmail: 'email is invalid.',
    RSVPGenericError: 'An error occurred. Please try again later.',
    RSVPSubmitConfirmation: 'Thanks for Registering! If you confirmed your email address, you\'ll get a new email with event details. If not, you\'ll get a temporary, one-time code email. Check spam if you don\'t get either.',
    RSVPCancelConfirmation: 'Thanks for canceling your attendance. If you confirmed your email address, you\'ll get a temporary, one-time code email. Check spam if you don\'t get it.',
    RSVPRecaptchaError: 'Unable to submit RSVP, please contact your site administrator.',
    RegistrationConfirmationTitle: 'Event registration',
    RegistrationConfirmationHeader: 'Thank you for registering',
    RegistrationConfirmationMessage: 'Your registration has been confirmed.',
    RegistrationLinkExpiredHeader: 'Your link has expired',
    RegistrationLinkExpiredMessage: 'Please return to the event details to register again.',
    RegistrationCancelationHeader: 'Your registration has been cancelled',
    RegistrationCancelationLinkExpiredMessage: 'Please return to the event details to cancel again.',
    ReturnToEventDetails: 'Return to event details',
    Previous: 'Previous',
    Next: 'Next',
    TodayColon: 'Today: ',
    PlaceholderImage: 'Placeholder image',
    BrowserNotSupported: 'This browser is not supported.',
    LoadingCalendar: 'Loading Calendar&hellip;',
    LoadMoreEvents: 'Load more events',
    NoEventsFound: 'No events found',
    NoEventsFoundFor: 'No events found for {{start}} - {{end}}',
    NoMoreEvents: 'No more events',
    NoResultsFor: 'No results for {{query}}',
    NoCategories: 'No categories available',
    AddToMyCalendar: 'Add to my calendar',
    VirtualEvent: 'Virtual Event',
    CopyVirtualEventLink: 'Copy virtual event link',
    Copy: 'Copy',
    CopiedExclamation: 'Copied!',
    CopyError: 'Copy Failed',
    JoinOnline: 'Join Online',
    Related: 'Related',
    RelatedEventCategories: 'Related event categories',
    AddToRSS: 'Add to RSS',
    OutlookICAL: 'Outlook/iCAL',
    ErrorContactingServerMessage: 'There was an error contacting the calendar server. Please try again.',
    ErrorLoadingEventData: 'There was an error loading event data. Please try again.',
    GenericError: 'An error occurred. Please try again later.',
    SubmitEvent: 'Submit Event',
    EventSubmissionHeading: 'Submit an event',
    Instructions: 'Instructions',
    EventSubmissionInstructions: 'Complete this form to request that an event be added to the calendar. Your requested event will be reviewed by an administrator.',
    asteriskFieldsRequired: 'All fields marked with an asterisk (*) are required.',
    Contact: 'Contact',
    publicSubmissionContactInstructions: 'We may contact you about your submission. We will not publish your contact information.',
    Verification: 'Verification',
    Passcode: 'Password',
    PasscodeHelperText: 'Enter password to access form.',
    passcodeInvalid: 'password is invalid.',
    Verify: 'Verify',
    Name: 'Name',
    NameHelperText: 'Enter your full name.',
    Email: 'Email',
    Phone: 'Phone',
    IAmA: 'I am a',
    IAmAPlaceholder: 'I am a&hellip;',
    submissionTypeHelperText: 'Select your relationship to the school.',
    Other: 'Other',
    typeOtherHelperText: 'Describe your relationship to the school.',
    CommentsToAdministrator: 'Comments to Administrator',
    Comments: 'Comments',
    CommentsHelperText: 'We will not publish your comments.',
    EventDetails: 'Event Details',
    PrimaryCalendar: 'Primary calendar',
    categoryHelperText: 'Select one.',
    EventTitle: 'Event Title',
    EventDescription: 'Event description',
    From: 'From',
    To: 'To',
    to: 'to',
    AllDayEvent: 'All day event',
    SuggestedCategories: 'Suggested event categories',
    SuggestedCategoriesHelperText: 'Categories filter events on the published calendar. Enter comma-separated words such as: academics, athletics, basketball.',
    EventLocation: 'Event Location',
    LocationName: 'Location name',
    PhysicalAddress: 'Physical Address',
    WebConferenceLink: 'Web Conference Link',
    ButtonLabel: 'Button Label',
    conferenceButtonLabelHelperText: 'Enter the text to display as a button that links to the online event.',
    SameAsSubmitter: 'Same As Submitter',
    EventOrganizer: 'Event Organizer',
    OrganizerName: 'Organizer Name',
    organizerNameHelperText: 'Enter full name.',
    OrganizerEmail: 'Organizer email',
    OrganizerPhone: 'Organizer phone',
    TicketsAndCost: 'Tickets and Cost',
    EventCost: 'Event Cost',
    ticketOptionHelperText: 'Select one.',
    Price: 'Price',
    eventPriceValidationMessage: 'A valid price is required.',
    eventPriceRangeValidationMessage: 'A valid price range is required.',
    EventCurrency: 'Event Currency',
    TicketLink: 'Ticket Link',
    ticketButtonLabelHelperText: 'Enter the text to display as a button that links to the ticketing platform.',
    sampleURL: 'https://www.example.com',
    EndOfPriceRange: 'End of Price Range',
    Cancel: 'Cancel',
    SubmitEvent: 'Submit Event',
    EventSubmissionFormSubmittedHeading: 'Thank you for your request',
    EventSubmissionFormSubmittedMessage: 'We will review your event request and reach out with any questions.',
    ReturnToCalendar: 'Return to Calendar',
    EventSubmission: 'Event Submission',
    EventSubmissionDescription: 'Submit this form to request an event be added to the calendar',
    submissionNameValidationMessage: 'Name is required.',
    categoryValidationMessage: 'Calendar is required.',
    titleValidationMessage: 'Event Name is required.',
    submissionTypeValidationMessage: '"I am a" is required.',
    typeOtherValidationMessage: '"I am a" is required.',
    submissionEmailValidationMessage: 'A valid email is required.',
    organizerEmailValidationMessage: 'A valid email is required.',
    toDateValidationMessage: '"From" date cannot be after "To" date.',
    toDatetimeValidationMessage: '"From" date/time cannot be after "To" date/time.',
    categoriesValidationMessage: 'Categories cannot exceed 128 characters in length and cannot contain special characters.',
    Begins: 'Begins',
    Ends: 'Ends',
    Events: 'Events',
    EventSeries: 'Event Series',
    UpcomingEvents: 'Upcoming Events',
    eventSubmissionTypes: {
        Student: 'Student',
        FacultyMember: 'Faculty Member',
        StaffMember: 'Staff Member',
        CommunityMember: 'Community Member',
        Other: 'Other',
    },
    ticketCurrencyOptions: {
        USD: '($) US Dollar',
        CAD: '($) Canadian Dollar',
        EUR: '(&euro;) Euro',
        GBP: '(&pound;) British Pound',
    },
    ticketOptions: {
        '': 'No Price',
        FREE: 'Free',
        ONE_PRICE: 'One Price',
        PRICE_RANGE: 'Price Range',
    },

    SubmitYourEvent: 'Submit your event',
    FooterSubmitEventMessage: 'To have your event considered for listing on the events calendar, please <a href="">submit here</a>.',
    LocationInfo: 'Location Info',
    Zoom: 'Zoom',
    Free: 'Free',
    currencySymbols: {
        USD: '$',
        CAD: '$',
        EUR: '&euro;',
        GBP: '&pound;',
    },
});